<template>
  <h2 class="info_head">
    <span class="head_text"><i class="icon"></i><slot name="title"></slot></span>
    <slot name="botton"></slot>
  </h2>
</template>

<script>
export default {
  name:'headDetail',
}
</script>

<style lang="stylus" scoped>
$color-main = #22B3EB
.info_head
  font-size 16px
  color #000
  display flex
  justify-content: space-between
  align-items: center
  margin-bottom 26px
  width 100%
  .head_text
    display flex
    align-items: center
  .icon
    width 13px
    height 13px
    border 3px solid $color-main
    border-radius: 50%;
    display: inline-block;
    margin-right 10px
</style>


// WEBPACK FOOTER //
// src/components/headDetail.vue